import { Label } from "../../atoms/body-text";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { PlaceholderImage, HeightVariant } from "../../atoms/placeholder-image";
import { Link } from "../../atoms/link";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Component } from "react";
export var TaxonomyTemplate;
(function (TaxonomyTemplate) {
    TaxonomyTemplate["BASIC"] = "BASIC";
    TaxonomyTemplate["HERO"] = "HERO";
})(TaxonomyTemplate || (TaxonomyTemplate = {}));
class Node extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            onLoad: true,
        };
        this.onImageLoad = () => {
            this.setState({ onLoad: false });
        };
    }
    render() {
        const { name, srcM = M.empty(), selectedTaxonomy, hideTaxonomyImage, index, template, onClickM = M.empty(), imgUrl, } = this.props;
        return (React.createElement("div", { className: cn({
                [styles.selectedContainerHero]: template === TaxonomyTemplate.HERO,
            }, selectedTaxonomy === index
                ? styles.selectedContainer
                : styles.unSelectedContainer), onClick: M.fromMaybe(onClickM, () => { }) },
            this.state.onLoad && (React.createElement(PlaceholderImage, { variant: !hideTaxonomyImage
                    ? HeightVariant.Taxonomy
                    : HeightVariant.HideTaxonomy })),
            template === TaxonomyTemplate.HERO ? (React.createElement("img", { src: imgUrl + `${"?w=100"}`, className: cn(styles.imageHero), loading: "lazy" })) : (M.foldMapConst((src) => (React.createElement("img", { className: cn(styles.imageHero, hideTaxonomyImage ? styles.hidden : styles.imageShorts), src: src, onLoad: this.onImageLoad })), React.createElement("div", { className: styles.selectedPlaceholder }, name.substring(0, 1)), srcM)),
            React.createElement(Label, null,
                React.createElement("div", { className: styles.title }, name)),
            template === TaxonomyTemplate.BASIC && (React.createElement("div", { className: cn(styles.underline, selectedTaxonomy === index ? styles.active : styles.inactive) }))));
    }
}
export const Taxonomy = ({ name, srcM = M.empty(), urlM = M.empty(), selectedTaxonomy, hideTaxonomyImage, index, template, onClickM = M.empty(), isShorts = false, imgUrl, }) => {
    return (React.createElement(React.Fragment, null, isShorts ? (React.createElement(Node, { name: name, srcM: srcM, onClickM: onClickM, selectedTaxonomy: selectedTaxonomy, index: index, hideTaxonomyImage: hideTaxonomyImage, template: template, imgUrl: imgUrl })) : (React.createElement(RenderMaybe, null, M.map((url) => (React.createElement(Link, { href: url },
        React.createElement(Node, { name: name, srcM: srcM, onClickM: onClickM, selectedTaxonomy: selectedTaxonomy, index: index, hideTaxonomyImage: hideTaxonomyImage, template: template, imgUrl: imgUrl }))), urlM)))));
};

